import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AuthService } from '../services/auth.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-trial-expired',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ToastModule],
  providers: [MessageService],
  templateUrl: './trial-expired.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './trial-expired.component.scss'
})
export class TrialExpiredComponent {
  loading = false;

  constructor(
    private authService: AuthService,
    private messageService: MessageService
  ) { }

  onContinueTrial() {
    this.sendEmailAction('continue_trial');
  }

  onTruncateAndNew() {
    this.sendEmailAction('truncate_new');
  }

  private sendEmailAction(action: string) {
    this.loading = true;
    // Assuming backend endpoint or placeholder. If the exact endpoint isn't known,
    // we can use a generic approach or we will just use a fake call/existing service if there's one.
    // The prompt says: "send an email(backend)"
    // I will mock this or use an existing service method if one fits. Let's add a dummy HTTP call in AuthService or just mock it here.
    const user = this.authService.getUserData();
    const payload = {
      username: user?.name || user?.email,
      action: action
    };

    // We can add sendTrialAction to AuthService, let's pretend it exists or just simulate it for now.
    // Since I must edit authService too, I will add sendTrialExpiredAction to AuthService.
    this.authService.sendTrialExpiredAction(payload).subscribe({
      next: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Your request has been submitted successfully. An email has been sent.'
        });
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to process your request. Please try again.'
        });
      }
    });
  }
}
